import { makeActionCreator } from '../../config/store/utils'
import { getComplainsList, getComplainDetail } from '../../services/charts'

export const COMPLAINS = 'COMPLAINS'
export const COMPLAINSDETAILS = 'COMPLAINSDETAILS'
export const COMPLAINS_ERROR = 'COMPLAINS_ERROR'
export const COMPLAINSDETAILS_ERROR = 'COMPLAINS_ERROR'
export const COMPLAINS_SUCCESS = 'COMPLAINS_SUCCESS'
export const COMPLAINSDETAILS_SUCCESS = 'COMPLAINSDETAILS_SUCCESS'
export const onComplains = makeActionCreator(COMPLAINS)
export const onComplainsDetails = makeActionCreator(COMPLAINSDETAILS)
export const onComplainsError = makeActionCreator(COMPLAINS_ERROR, 'payload')
export const onComplainsDetailsError = makeActionCreator(COMPLAINSDETAILS_ERROR, 'payload')
export const onComplainsSuccess = makeActionCreator(COMPLAINS_SUCCESS, 'payload')
export const onComplainsDetailsSuccess = makeActionCreator(COMPLAINSDETAILS_SUCCESS, 'payload')
export const onComplainsOrdersThunk = (idEntity, year, category) => async dispatch => {
  dispatch(onComplains())

  try {
    const response = await getComplainsList({ idEntity, year, category })

    if (response.data.success !== 'OK') {
      return dispatch(onComplainsError(response.data.errores))
    }

    const singleObj = response.data.payload.find(item => item.year === year)
    const total = singleObj.data.find(item => item.type === 'KPI_GENERAL')
    const categories = singleObj.data.filter(item => item.type !== 'KPI_GENERAL')
    const payload = { categories, total }

    return dispatch(onComplainsSuccess(payload))
  } catch (error) {
    return dispatch(onComplainsError(error))
  }
}
export const onComplainsDetailsThunk = (idEntity, year, category, type) => async dispatch => {
  dispatch(onComplainsDetails())

  try {
    const response = await getComplainDetail({ idEntity, year, category, type })

    if (response.data.success !== 'OK') {
      return dispatch(onComplainsDetailsError(response.data.errores))
    }

    return dispatch(onComplainsDetailsSuccess(response.data.payload))
  } catch (error) {
    return dispatch(onComplainsDetailsError(error))
  }
}
